import React from 'react'
import { useParams } from 'react-router-dom'

import AssemblingManagementUnit from '@components/assembling/partition/AssemblingManagementUnit'

export default function AssemblingManagementPage () {
  const { type = 'orders' } = useParams<any>()
  const [ title, setTitle ] = React.useState<string>('Сборка')

  return (
    <div className="AssemblingManagementPage">
      <h1 className="u-heading">{ title }</h1>
      <AssemblingManagementUnit 
        type={type} 
        onChangePage={setTitle} 
      />
    </div>
  )
}
